import { Injectable, ChangeDetectorRef } from '@angular/core';
import { HttpResponse } from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class GoogleMapsService {
  constructor(private ref: ChangeDetectorRef) { }

  getDirections(travelMode: string, originLatLng: any, destLatLng: any, cb) { // convert to promise later
    const directionsService = new google.maps.DirectionsService();
    if (!travelMode) {
      cb({ status: 'FAIL' });
      this.ref.detectChanges();
    }
    directionsService.route({
      origin: originLatLng,
      destination: destLatLng,
      travelMode: google.maps.TravelMode[travelMode] || 'DRIVING',
    }, (data) => {
      cb(data);
      this.ref.detectChanges();
    });
  }

  getDrivingDistance(originLatLng: any, destLatLng: any, cb) { // convert to promise later
    const directionsService = new google.maps.DirectionsService();
    directionsService.route({
          origin: originLatLng,
      destination: destLatLng,
      travelMode: google.maps.TravelMode['DRIVING'],
    }, (data: any) => {
      if (data && data.status === 'OK' && data.routes[0]) {
        cb(data.routes[0].legs[0].distance);
      } else {
        cb({
          text: "Loading...",
          value: null,
        });
      }
      this.ref.detectChanges();
    });
  }

  getCoordsGivenAddress(streetAddress, city, state, cb) {
    const geocoding = new google.maps.Geocoder();
    geocoding.geocode({
      address: `${streetAddress},${city},${state}`,
    }, (data: any) => {
      if (data && data[0] && data[0].geometry && data[0].geometry.location) {
        cb(data[0].geometry.location);
      } else {
        cb(null);
      }
      this.ref.detectChanges();
    })
  }

  private handleError(error: HttpResponse<Object> | any) {
    console.error(error);
    return error;
  }

  private handleGoogleMapsApiResponse(res: HttpResponse<Object>) {
    let body = res.body;
    return body || { };
  }
}
